export default __webpack_public_path__ + "858c83266f804af5a3c081718c310f1c.jpeg";